import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {HomeschoolingInitiativeComponent} from './homeschooling-initiative/homeschooling-initiative.component';
import {IntroductionToClassicalEducationComponent} from './introduction-to-classical-education/introduction-to-classical-education.component';
import {RecommendedCurriculumComponent} from './recommended-curriculum/recommended-curriculum.component';

// tslint:disable: max-line-length
const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		component: HomeComponent,
		data: {
			title: '',
			// description: handled in component
		},
	},
	{
		path: 'introduction-to-classical-education',
		pathMatch: 'full',
		component: IntroductionToClassicalEducationComponent,
		data: {
			title: 'Introduction to Classical education',
			// description: handled in component
		},
	},
	{
		path: 'recommended-curriculum',
		pathMatch: 'full',
		component: RecommendedCurriculumComponent,
		data: {
			title: 'Recommended Curriculum',
			// description: handled in component
		},
	},
	{
		path: 'homeschooling-initiative',
		pathMatch: 'full',
		component: HomeschoolingInitiativeComponent,
		data: {
			title: 'Homeschooling Initiative',
			// description: handled in component
		},
	},
	{
		path: '**',
		redirectTo: '/'
	}
];

// @ts-ignore
@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: 'enabled',
			scrollPositionRestoration: 'enabled',
			scrollOffset: [0, 60]
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
